import api from './base'

export default {
  get ({ businessUnitId, articleId }) {
    return api().get(`company/business_units/${businessUnitId}/articles/${articleId}/composition`)
  },
  getHistory ({ businessUnitId, articleId }) {
    return api().get(`company/business_units/${businessUnitId}/articles/${articleId}/composition_history`)
  },
  save ({ businessUnitId, articleId, items }) {
    return api().put(`company/business_units/${businessUnitId}/articles/${articleId}/composition`, items)
  },
  loadArticleCompositionMembership ({ businessUnitId, articleId }) {
    return api().get(`company/business_units/${businessUnitId}/articles/${articleId}/composition_membership`)
  }
}
